import React, { FunctionComponent } from 'react'
import EsimInfo from './eSimInfo'
import SelfSimInfo from './selfSimInfo'
import { TanCreateReq } from '@/services/mobi-api/sim/types'

interface Props {
  onClick: (req?: TanCreateReq) => void
  simtype: string | undefined
}

const Step2: FunctionComponent<Props> = ({ onClick, simtype }) => {
  return simtype === 'SELFSIM' ? <SelfSimInfo onClick={onClick} /> : <EsimInfo onClick={onClick} />
}
export default Step2
